import { store, getContext, getElement, useLayoutEffect } from '@wordpress/interactivity';
import DOMPurify from 'dompurify';

import './store';

/**
 * Adds feed-specific interactivity to the store.
 */
const { state } = store('mediapress-live', {
  state: {
    get entryIdAttr() {
      const context = getContext();
      return `entry:${context?.entry?.id}`;
    },
  },
  callbacks: {
    /**
     * Inject the blocks from the REST API response as inner HTML
     */
    renderBlocks: () => {
      const context = getContext();
      // eslint-disable-next-line react-hooks/rules-of-hooks
      useLayoutEffect(() => {
        const newContent = context?.entry?.content?.rendered;

        if (!newContent) {
          return;
        }

        const { ref } = getElement();

        /**
         * We need to allow iFrames to be rendered in the feed,
         * for example for the embed block.
         */
        ref.innerHTML = DOMPurify.sanitize(newContent, {
          ADD_TAGS: ['iframe'],
          ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'scrolling'],
        });
      }, [context?.entry?.content?.rendered]);
    },
    updatePinnedEntry: () => {
      const clientContext = getContext();
      clientContext.entry = state.pinnedEntry;
    },
  },
  actions: {
    expandPinnedEntry: () => {
      state.pinnedEntryIsCollapsed = false;
    },
  },
});
